module.exports = {
      id: "ic-volatility-usage",
      viewBox: "0 0 17 16",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-volatility-usage",
      toString: function () {
        return this.url;
      }
    }